

















































































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { remToPx } from "@/common/dom.functions";
import { InformationType } from "@/common/models";
import { UsePopup } from "@/components/root/popup/popup.state";
export default Vue.extend({
  components: {
    AppTableRow,
    SensitivityLabel,
  },
  props: ["source"],
  setup() {
    const showPiisPopup = (piis: InformationType[], event: MouseEvent) => {
      UsePopup.showDisplayPopup({
        type: "TextDisplayPopup",
        event,
        items: piis.map((d) => d.labelName),
        position: "left",
        width: remToPx(30),
      });
    };

    return { showPiisPopup };
  },
});
